var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-5 align-items-center justify-content-center"},[_c('iframe',{attrs:{"src":"https://docs.google.com/forms/d/e/1FAIpQLSfyHn3pwVALHxkn3iHCiiA03tteRVw3LxaDzLK6Ta-Cgf9TdQ/viewform?embedded=true","width":"640","height":"2394","frameborder":"0","marginheight":"0","marginwidth":"0"}},[_vm._v("Cargando…")])])
}]

export { render, staticRenderFns }